/**
 * Subtitle segments for a shops-directory row.
 * Order: tenant (optional) · location · description · place (geo) · distance.
 * Place + distance persist whenever labels are supplied — callers gate on
 * `userPosition !== null`, not on `sort === 'distanceAsc'`.
 *
 * A13b: `location` must already be presence-resolved
 * (`resolveShopLocationLabel` / Shipping only) — never pass raw null ONLINE_ONLY
 * as locationMissing.
 */
export type ShopDirectorySubtitleInput = {
  readonly tenantLabel?: string | null;
  /**
   * Already resolved location line (ops address, locationMissing, or
   * `customerPresence.shippingOnly` for ONLINE_ONLY).
   */
  readonly location: string;
  readonly description?: string | null;
  readonly placeLabel?: string | null;
  readonly distanceLabel?: string | null;
};

export function buildShopDirectorySubtitleParts(
  input: ShopDirectorySubtitleInput,
): string[] {
  const placePart =
    typeof input.placeLabel === 'string' && input.placeLabel.trim().length > 0
      ? input.placeLabel.trim()
      : null;
  const distancePart =
    typeof input.distanceLabel === 'string' && input.distanceLabel.trim().length > 0
      ? input.distanceLabel.trim()
      : null;
  const descriptionPart =
    typeof input.description === 'string' && input.description.trim().length > 0
      ? input.description.trim()
      : null;
  return [
    input.tenantLabel ?? null,
    input.location,
    descriptionPart,
    placePart,
    distancePart,
  ].filter((part): part is string => part !== null && part.length > 0);
}
